const Icons = {
  logo: require('../assets/img/logo.png'),
  bg115: require('../assets/demo/bg/bg-115.jpg'),
  bg116: require('../assets/demo/bg/bg-116.jpg'),
  bg117: require('../assets/demo/bg/bg-117.jpg'),
  bg118: require('../assets/demo/bg/bg-118.jpg'),
  bg119: require('../assets/demo/bg/bg-118.jpg'),
  bg120: require('../assets/demo/bg/bg-120.jpg'),
  bg122: require('../assets/demo/bg/bg-122.jpg'),

  centrisMLS: require('../assets/img/centrisMLS.jpg'),
  about: require('../assets/img/about.jpg'),

  client1: require('../assets/demo/clients/client-1.png'),
  client2: require('../assets/demo/clients/client-2.png'),
  client3: require('../assets/demo/clients/client-3.png'),
  client4: require('../assets/demo/clients/client-4.png'),
  client5: require('../assets/demo/clients/client-5.png'),
  client6: require('../assets/demo/clients/client-6.png'),
  avatar1: require('../assets/demo/clients/client-6.png'),
  Location: require('../assets/icon/flags/Location.png'),
  BY_Emmy_3: require('../assets/BY_Emmy_3.png'),
  happy_house: require('../assets/happy_house.jpg'),
  White_collar: require('../assets/icon/White-collar.png'),

}
export default Icons
